const host = window.location.hostname;
const isProd = host === 'cw-backoffice.zeroemissions.jp';
const isPreProd = host === 'cw-backoffice-preprod.zeroemissions.jp';
const APPCONFIG = {
  // endPoint: isProd ? 'https://api.zeroemissions.jp/api' : isPreProd ? 'https://api-preprod.zeroemissions.jp/api' : 'https://api-dev.zeroemissions.jp/api',
  endPoint: 'https://admin.carbonwallet.zeroemissions.jp/api'
};
export default APPCONFIG;
